export const PurchaseOrderOtherInfoValidation = (formData) => {
    const errors = {};
   
    if (!formData.vc_Notes || formData.vc_Notes==="") {
        errors.vc_Notes = 'This field is required';
    }
    
    return errors;
};
